// src/utils/m172Client.js
//
// NEW — shared client for m172-agentDevProfileManager, used by both
// AgentDevProfilePanel and AgentDevReportDialog. Attaches the user's
// Firebase ID token and never throws on HTTP status (callers inspect
// res.status / res.data.success).

import axios from 'axios';
import { FB_URL } from '../store/actions/types';

// ADJUST this import to match how App.js / fbConfig.js import Firebase —
// it must be the SAME initialised instance, or currentUser will be null.
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const M172_URL = `${FB_URL}/m172-agentDevProfileManager`;

export async function getAuthHeaders() {
  const auth = typeof firebase.auth === 'function' ? firebase.auth() : firebase.auth;
  const user = auth && auth.currentUser;
  if (!user) throw new Error('You are signed out. Please sign in again.');
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

// Pulls the server's actual error message out of an axios error.
export function describeError(e) {
  const serverMsg = e.response?.data?.error || e.response?.data?.message;
  if (e.response) console.error('m172 request failed:', e.response.status, e.response.data);
  return serverMsg || e.message;
}

// uid is still sent in the body so this works against the OLD m172 during
// rollout; the new m172 ignores it and uses the token.
export async function callM172({ uid, agentId, operation, extra = {}, timeout }) {
  const headers = await getAuthHeaders();
  return axios.post(
    M172_URL,
    { params: { agentId, uid, operation, ...extra } },
    { headers, validateStatus: () => true, timeout }
  );
}